import { Actions } from '@components/shared/Actions'
import { EditIcon } from '@assets/svgs/EditIcon'
import { DeleteIcon } from '@assets/svgs/DeleteIcon'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { AdditionalDepreciationItemProps } from '../context/types'

interface ParseAdditionalDepreciationGridProps {
  data: AdditionalDepreciationItemProps[]
  actionsDisabled: boolean
  onEdit: (data: AdditionalDepreciationItemProps) => void
  onDelete: (data: AdditionalDepreciationItemProps) => void
}

export const parseAdditionalDepreciationGrid = ({
  data,
  actionsDisabled,
  onEdit,
  onDelete
}: ParseAdditionalDepreciationGridProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'accountingCode',
      columnName: 'Conta',
      align: 'center',
      value: item.accountingCode || '-',
      minWidth: '8rem',
      sortable: true
    },
    {
      id: 'accountingDescription',
      columnName: 'Descrição Conta',
      align: 'center',
      value: item.accountingDescription || '-',
      minWidth: '20rem',
      sortable: true
    },
    {
      id: 'value',
      columnName: 'Valor Depreciação Adicional (R$)',
      align: 'center',
      currency: true,
      value: item.value || 0,
      minWidth: '14rem',
      sortable: true
    },
    {
      id: 'observations',
      columnName: 'Observações',
      align: 'center',
      value: item.observations || '-',
      minWidth: '20rem',
      sortable: true
    },
    {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: (
        <Actions
          actions={[
            { label: 'Editar', icon: <EditIcon />, onClick: () => onEdit(item) },
            { label: 'Excluir', icon: <DeleteIcon />, onClick: () => onDelete(item) }
          ]}
          disabled={actionsDisabled}
        />
      )
    }
  ])

  return parsedData
}
